import React from "react";
import { Box, Typography, alpha, useTheme } from "@mui/material";

export default function TemplateSelector({ templates, selectedId, defaultTemplateId, onSelect, lang }) {
  const theme = useTheme();
  const sorted = React.useMemo(
    () => [...(templates || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
    [templates],
  );

  if (!sorted.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        {lang?.clippingNoTemplates || "No caption templates available."}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        overflowX: "auto",
        pb: 1,
        mx: -0.5,
        px: 0.5,
      }}
    >
      {sorted.map((tpl) => {
        const id = tpl.templateId;
        const selected = id === (selectedId || defaultTemplateId);
        return (
          <Box
            key={id}
            onClick={() => onSelect?.(id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") onSelect?.(id);
            }}
            sx={{
              flex: "0 0 120px",
              cursor: "pointer",
              borderRadius: 2,
              border: "2px solid",
              borderColor: selected ? "primary.main" : "divider",
              bgcolor: selected ? alpha(theme.palette.primary.main, 0.06) : "background.paper",
              overflow: "hidden",
              transition: "border-color 0.15s, box-shadow 0.15s",
              boxShadow: selected ? `0 0 0 3px ${alpha(theme.palette.primary.main, 0.2)}` : "none",
            }}
          >
            <Box
              component="img"
              src={tpl.gif || tpl.thumbnail || tpl.preview}
              alt={tpl.displayName || tpl.name}
              sx={{ width: "100%", height: 72, objectFit: "cover", display: "block" }}
            />
            <Typography
              variant="caption"
              fontWeight={selected ? 700 : 600}
              sx={{ display: "block", px: 1, py: 0.75, lineHeight: 1.3, textAlign: "center" }}
            >
              {tpl.displayName || tpl.name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
